module.exports = __webpack_public_path__ + "img/rascrut-7.b9b0530c.jpg";